import { Component } from '@angular/core';
import { TableActionsTemplate } from 'src/app/@amiga-pyme/table-actions/templates/table-actions.template';
import { IAmiHead } from 'src/app/@amiga-pyme/components/ami-head/ami-head.interface';
import { ReportDigemidService } from '../digemid.service';
import { IReportDigemidResponse } from '../digemid.interface';

@Component({
  selector: 'pg-report-digemid',
  templateUrl: './digemid.component.html'
})
export class ReportDigemidComponent extends TableActionsTemplate {
  settingsAmiHead: IAmiHead = {
    title: 'Reporte Digemid',
    addressImg: 'reports'
  };

  constructor(private serviceBase: ReportDigemidService) {
    super('', serviceBase);
  }

  ngOnInit(): void {
    this.table.settings = {
      title: 'Reporte Digemid',
      columns: [
        { header: 'Sucursal', field: 'branchStoreName' },
        { header: 'Codigo establecimiento', field: 'establishmentCode' },
        { header: 'Codigo de producto', field: 'productCode' },
        {
          header: 'Precio de empaque',
          field: 'packagingPrice',
          pipe: 'Currency'
        },
        { header: 'Precio unitario', field: 'unitPrice', pipe: 'Currency' }
      ],
      exportData: true,
      filterColumns: true
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IReportDigemidResponse[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
